export const bnbMultisender = "0x241C9907985dd1d24A07CC585794c79DeEF8bAF4";
export const ethMultisender = "0x0172dC1f6E134Bef6Cfd40d1BcD70dBDbEd179Ee";
export const trxMultisender = "TQLCUTAnKdSEwVDno3EKGNurbzM9pmzhvT";
export const default_RPC_URL = "TNTaCUvtKxSLavD1VgpcYiFNx2UhrHSoRP";
